const notificationTypes = ['AUTOMATED', 'MANUAL'] as const;
export type WaitlistNotificationType = (typeof notificationTypes)[number];

export const isWaitlistNotificationType = (type?: string): type is WaitlistNotificationType => {
  return notificationTypes.some((value) => value === type);
};

export const isFunction = (obj: unknown): obj is Function => typeof obj === 'function';
